import React from 'react';
import MyContentLoader from '../ContentLoader/ContentLoader';
import contentLoaderConfig from '../ContentLoader/ContentLoaderConfig';
import useWidthMeasurement from '../../hooks/useWidthMeasurement';

const LoadingAnimation = () => {
  const windowType = useWidthMeasurement();

  return windowType ? (
    <>
      <MyContentLoader config={contentLoaderConfig[windowType]}>
        <MyContentLoader
          config={contentLoaderConfig[windowType]}
          isChildrenLoader
        />
        <MyContentLoader
          config={contentLoaderConfig[windowType]}
          isChildrenLoader
        />
      </MyContentLoader>
      <MyContentLoader config={contentLoaderConfig[windowType]}>
        <MyContentLoader
          config={contentLoaderConfig[windowType]}
          isChildrenLoader
        />
        <MyContentLoader
          config={contentLoaderConfig[windowType]}
          isChildrenLoader
        />
      </MyContentLoader>
    </>
  ) : null;
};

export { LoadingAnimation as default };
